// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2xRoA","inner":"Form_inner__3Yv6s","range":"Form_range__36nbE","name":"Form_name__3i4rO","actions":"Form_actions__RGQj2"};